export enum TransferToEcomDetailActionTypes {
  TRANSFER_TO_ECOM_GET_DETAILS_SUCCESS = "TRANSFER_TO_ECOM_GET_DETAILS_SUCCESS",
  RESET_TRANSFER_TO_ECOM_DETAILS = "RESET_TRANSFER_TO_ECOM_DETAILS",
}
